import "./display.scss";
function Display({ children, Display = "Normal", y = "flex-top" }) {
  return (
    <div
      className={`Display
         Display-${Display} 
         Display-${y}`}
    >
      {children}
    </div>
  );
}
export default Display;
